import { ChangeEvent } from "react";

import FormControlLabel from "@mui/material/FormControlLabel";
import BaseSwitch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";

import {
  getRouteFormProperty,
  setRouteFormProperty,
} from "../../../../slices/routes";
import UpstreamTunnelSshPolicyPicker from "../fields/UpstreamTunnelSshPolicyPicker";
import { useDispatch, useSelector } from "@/store";
import { useGetSettingsQuery } from "@/store/enhancedApi";

interface SshTunnelingProps {
  readonly: boolean;
}
export function SshTunneling({ readonly }: SshTunnelingProps) {
  const dispatch = useDispatch();
  const organizationId = useSelector((state) => state.current.organizationId);
  const clusterId = useSelector((state) => state.current.clusterId);
  const { data: settings } = useGetSettingsQuery({
    organizationId,
    clusterId,
  });
  const sshConfigured = Boolean(
    settings &&
    settings.sshAddress &&
    settings.sshUserCaKey &&
    settings.sshHostKeys?.length,
  );
  const checked = Boolean(
    useSelector(getRouteFormProperty("upstreamTunnel", false)),
  );

  const tooltipTitle = sshConfigured
    ? null
    : "SSH is not configured for this cluster. Configure SSH first in  Settings -> SSH.";

  function onToggleSshTunneling(
    _event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) {
    if (checked) {
      dispatch(setRouteFormProperty({ path: "upstreamTunnel", value: {} }));
    } else {
      dispatch(
        setRouteFormProperty({ path: "upstreamTunnel", value: undefined }),
      );
    }
  }

  return (
    <div className="grid xl:flex gap-2">
      <Tooltip title={tooltipTitle}>
        <FormControlLabel
          control={
            <BaseSwitch
              checked={checked}
              disabled={readonly || !sshConfigured}
              onChange={onToggleSshTunneling}
            />
          }
          label="Reverse SSH Tunnel"
          slotProps={{
            typography: {
              className: "sr-only",
            },
          }}
        />
      </Tooltip>
      {checked && (
        <label className="grid lg:flex lg:flex-1  gap-2 items-center">
          <span>Upstream SSH Policy</span>
          <div className="flex-1 min-w-0">
            <UpstreamTunnelSshPolicyPicker readonly={readonly} />
          </div>
        </label>
      )}
    </div>
  );
}
